import React from 'react';
import './index.scss';
import { NavLink } from 'react-router-dom'
const $ = window.$;
let Swiper = window.Swiper
class Lists extends React.PureComponent {
  constructor(props){
    super(props)
    this.state = {}
  }
  render () {
    return (
      <div className="produce-lists-container">
        {
          this.props.dataLists.map((item,index)=>
              <div key={index} className='products-lists'>
                {item.title ?
                    <p><i></i><span>{item.title}</span></p> : ''
                }
                {item.data ?
                  <div dangerouslySetInnerHTML={{ __html: item.data}}></div> : ''
                }
                {item.imgPath?
                <img data-src={item.imgPath} alt="" data-srcset={item.imgHDPath} className="lists-img swiper-lazy"/>:""
                }
              </div>
          )
        }
      </div>
    )
  }
}
class HeaderSwiper extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
    }
  }
  componentDidMount() {
    // new Swiper('.header-swiper', {
    //     // speed: 500,
    //     autoHeight: true,
    //     loop: true,
    //     autoplay: true,
    //     delay: Number(this.props.delay),
    //     lazy: {
    //       loadOnTransitionStart: true
    //     }
    //   })
  }
  render () {
    return (
      <section className="swiper-container header-swiper">
        <div className="swiper-wrapper">
          {
            this.props.headerDataLists.map((item, index) =>
            <div  key={item.imgPath} className="swiper-slide">
              {
              item.attachURL && item.attachURL !== '/' ?
                <a  href={item.attachURL}>
                  <img data-src={item.imgPath} alt="" data-srcset={item.imgHDPath} width="100%" height="100%" className="header-swiper-img swiper-lazy" />
                </a>
                :
                <img  data-src={item.imgPath} alt="" data-srcset={item.imgHDPath} width="100%" height="100%" className="header-swiper-img swiper-lazy" />
              }
            </div>
            )
          }
        </div>
      </section>
    )
  }
}
// 工作机会的滚动图
class RecruitSwiper extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
    }
  }
  componentDidMount() {
    new Swiper('.recruit-swiper', {
        speed: 500,
        slidesPerView: 'auto',
        loopedSlides: 8,
        lazy: {
          loadOnTransitionStart: true
        }
      })
  }
  render () {
    return (
      <section className="swiper-container recruit-swiper">
        <div className="swiper-wrapper">
          {
            this.props.headerDataLists.map((item, index) =>
            <div  key={item.imgPath} className="swiper-slide">
              {
              item.attachURL && item.attachURL !== '/' ?
                <a  href={item.attachURL}>
                  <img src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" className="header-swiper-img" />
                </a>
                :
                <img  src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" className="header-swiper-img" />
              }
            </div>
            )
          }
        </div>
      </section>
    )
  }
}
class ColList extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  render () {
    return (
      <div className='col-lists'>
        {
          this.props.ColIconData.map((item, index) =>
            <dl key={index}>
              <dt>
                <img data-src={item.imgPath} alt="" data-srcset={item.imgHDPath} className="swiper-lazy"/>
              </dt>
              <dd dangerouslySetInnerHTML={{__html: item.title}}></dd>
            </dl>
          )
        }
      </div>
    )
  }
}

class TwoColList extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  render () {
    return (
      <div className='two-col-lists'>
        {
          this.props.ColIconData.map((item, index) =>
            <div  className='two-col-lists-items' key={index}>
              <img data-src={item.imgPath} alt="" data-srcset={item.imgHDPath} className="swiper-lazy"/>
              <span dangerouslySetInnerHTML={{__html: item.title}}></span>
            </div>
          )
        }
      </div>
    )
  }
}


class NavBars extends React.PureComponent {
  constructor(props){
    super(props)
    this.state = {
      img:{
          imgPath: require("img/close.png"), imgHDPath: `${require("img/close.png")} 1x,${require("img/close@2x.png")} 2x,${require("img/close@3x.png")} 3x`,
        }
    }
  }
  // handleShowNav () {
  //   const dom = document.getElementsByClassName('pop-bar')[0]
  //   dom.style.animation = 'moveBottom .3s'
  //   console.log(dom, 'dom')
  //   setTimeout(() => {
  //     console.log(this.props.handleShowNav, 'showfun')
  //     this.props.handleShowNav()
  //   }, 0);
  // }
  render () {
    return (
      <div className="pop-bar">
        <img src={this.state.img.imgPath} className="close-icon swiper-lazy" alt=""
          srcSet={this.state.img.imgHDPath} width="100%" height="100%" onClick={this.props.handleShowNav}/>
        <p className="title">{this.props.NavBarsData.title}</p>
        <ul className="lists">
          {
            this.props.NavBarData.map((item, index) =>
              <li className="list" key={index}>
                <NavLink className="nav-link" to={this.props.NavBarsData.rootPath + item.url}
                  onClick={this.props.handleShowNav}>
                  {item.name}
                </NavLink>
              </li>
            )
          }
        </ul>
      </div>
    )
  }
}
class NavContainer extends React.Component {
  // constructor (props){
  //   super(props)
  // }
  handleNavToggle(e, value) {
    // this.state.navSwiper.slideTo(value)
    // 点击会获得最里面的值
    const ev = e || window.event;
    const target = ev.target || ev.srcElement;
    this.handlePosition(target)
  }
  handlePosition(dom) {
    const that = $(dom)
    const moveX = that.position().left + that.parent().parent().scrollLeft();
    // console.log(that.parent().parent().parent(), 'that.parent().parent().parent()')
    const pageX = document.documentElement.clientWidth;
    const blockWidth = that.width();
    const left = moveX - (pageX / 2) + blockWidth / 2;
    // console.log(moveX, 'move')
    // console.log(pageX, 'pageX')
    // console.log(blockWidth, 'df')
    // console.log(left)
    $('.details-nav').scrollLeft(left)
  }
  render () {
    return (
      <ul className="details-nav">
        {
          this.props.title.map((item, index) =>
            <li className="navbars-title" key={index}>
              <NavLink to={this.props.NavBarsData.rootPath+item.url}
                activeClassName="active" onClick={(e) => this.handleNavToggle(e, item.id)}>{item.name}</NavLink>
            </li>
          )
        }
      </ul>
    )
  }
}
export { Lists, HeaderSwiper, ColList, NavBars, NavContainer, RecruitSwiper,TwoColList}
